
import { ImageFileData, CompressionResult } from '@/types/imageFile';

export const createImageFileData = (file: File): ImageFileData => ({
  file,
  isCompressing: false,
  isRemovingBackground: false,
  status: 'pending',
  retryCount: 0
});

export const updateFileStatus = (
  filesData: ImageFileData[],
  index: number,
  updates: Partial<ImageFileData>
): ImageFileData[] => {
  return filesData.map((fileData, i) => 
    i === index ? { ...fileData, ...updates } : fileData
  );
};

export const updateFileCompression = (
  filesData: ImageFileData[],
  index: number,
  compression: CompressionResult
): ImageFileData[] => {
  return updateFileStatus(filesData, index, {
    compression,
    isCompressing: false,
    status: 'completed',
    error: undefined
  });
};

export const setFileError = (
  filesData: ImageFileData[],
  index: number,
  error: string
): ImageFileData[] => {
  return updateFileStatus(filesData, index, {
    isCompressing: false,
    status: 'failed',
    error,
    retryCount: filesData[index].retryCount + 1
  });
};

export const setFileProcessing = (
  filesData: ImageFileData[],
  index: number
): ImageFileData[] => {
  return updateFileStatus(filesData, index, {
    isCompressing: true,
    status: 'processing',
    error: undefined
  });
};
